import { displayDate } from "~/plugins/functions/display";

export interface IModelUserResponse {
  id: number;
  username: string;
  email: string;
  phone: string;
  department: string;
  accessKeyId: string | null;
  secretAccessKeyId: string | null;
  status: string;
  secretExpiredAt: string | null;
  lastLoginAt: string | null;
  lastActiveAt: string | null;
  originAppId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  departmentMapping: IDepartmentMapping;
  role: string;
  roles: any[];
  createdByUser: any;
}
export interface IDepartmentMapping {
  id: number;
  department: string;
  subDepartment: string;
  functionCode: string;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelUser {
  id: number;
  username: string;
  email: string;
  phone: string;
  accessKeyId: string | null;
  secretAccessKeyId: string | null;
  status: string;
  secretExpiredAt: string | Date | null;
  lastLoginAt: string | Date | null;
  lastActiveAt: string | Date | null;
  originAppId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  departmentMapping: IDepartmentMapping;
  subDepartment: string;
  department: string;
  functionCode: string;
  role: string;
  createdByUser: any;
  createdBy: string;
  displayCreatedAt: string;
  displayUpdatedAt: string;
  roles: any[];
  displayRole: string;

  constructor(props = {} as IModelUserResponse) {
    props = props ?? {};
    this.id = props.id;
    this.username = props.username || '-';
    this.email = props.email || '-';
    this.phone = props.phone || '-';
    this.accessKeyId = props.accessKeyId;
    this.secretAccessKeyId = props.secretAccessKeyId;
    this.status = props.status;
    this.secretExpiredAt = props.secretExpiredAt;
    this.lastLoginAt = props.lastLoginAt;
    this.lastActiveAt = props.lastActiveAt;
    this.originAppId = props.originAppId;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.deletedAt = props.deletedAt;
    this.departmentMapping = props.departmentMapping;
    this.subDepartment = props.departmentMapping?.subDepartment || '';
    this.department = props.departmentMapping?.department || '';
    this.functionCode = props.departmentMapping?.functionCode || '';
    this.role = props.role || '';
    this.createdByUser = props.createdByUser;
    if (this.createdByUser) {
      this.createdBy = this.createdByUser?.username || '';
    } else {
      this.createdBy = '-';
    }
    this.displayCreatedAt = displayDate(this.createdAt);
    this.displayUpdatedAt = displayDate(this.updatedAt);
    this.roles = props.roles || [];
    this.displayRole = this.roles[0]?.name || '-';
  }
}

export interface IPermission {
  name: string;
  permission: string;
  status: string;
}

export interface IRole {
  name: string;
  status: string;
  permissions: IPermission[];
}

export interface IUserScopeRelation {
  createdAt: string | Date;
  updatedAt: string | Date;
  userId: number;
  scopeMasterId: number;
}

export interface IUserTeamRelation {
  id: number;
  userId: number;
  team: string;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface IScope {
  id: number;
  name: string;
  scope: string;
  hostName: string | null;
  urlPath: string | null;
  type: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  user_scope_relations: IUserScopeRelation;
}

export interface IModelUserAssoResponse {
  id: number;
  username: string;
  email: string;
  phone: string;
  department: string;
  password: string;
  pinCode: string | null;
  accessKeyId: string | null;
  secretAccessKeyId: string | null;
  status: string;
  secretExpiredAt: string | Date | null;
  lastLoginAt: string | Date | null;
  lastActiveAt: string | Date | null;
  originAppId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  applications: any[];
  scopes: IScope[];
  roles: IRole[];
  avatar: string;
  departmentMapping: IDepartmentMapping;
  userTeamRelations: IUserTeamRelation[];
  userTeamList: IUserTeamRelation[];
  adminType: string;
}

export class ModelUserAsso {
  id: number;
  username: string;
  email: string;
  phone: string;
  department: string;
  password: string;
  pinCode: string | null;
  accessKeyId: string | null;
  secretAccessKeyId: string | null;
  status: string;
  secretExpiredAt: string | Date | null;
  lastLoginAt: string | Date | null;
  lastActiveAt: string | Date | null;
  originAppId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt: string | Date | null;
  applications: any[];
  scopes: IScope[];
  roles: IRole[];
  avatar: string;
  departmentMapping: IDepartmentMapping;
  subDepartment: string;
  functionCode: string;
  userTeamRelations: IUserTeamRelation[];
  userTeamList: IUserTeamRelation[];
  adminType: string;

  constructor(props: IModelUserAssoResponse = {} as IModelUserAssoResponse) {
    this.id = props.id;
    this.username = props.username;
    this.email = props.email;
    this.phone = props.phone;
    this.password = props.password;
    this.pinCode = props.pinCode;
    this.accessKeyId = props.accessKeyId;
    this.secretAccessKeyId = props.secretAccessKeyId;
    this.status = props.status;
    this.secretExpiredAt = props.secretExpiredAt;
    this.lastLoginAt = props.lastLoginAt;
    this.lastActiveAt = props.lastActiveAt;
    this.originAppId = props.originAppId;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.deletedAt = props.deletedAt;
    this.applications = props.applications || [];
    this.scopes = props.scopes || [];
    this.avatar = props.avatar;
    this.roles =
      props.roles?.map((role) => ({
        ...role,
        permissions: role.permissions || [],
      })) || [];
    this.departmentMapping = props.departmentMapping;
    this.subDepartment = props.departmentMapping?.subDepartment || '';
    this.department = props.departmentMapping?.department || '';
    this.functionCode = props.departmentMapping?.functionCode || '';
    this.userTeamRelations = props.userTeamRelations || [];
    this.userTeamList = this.userTeamRelations;
    this.adminType = props.adminType;
  }
}

export interface IModelUserData {
  originAppId: number;
  username: string;
  email: string;
  phone: string;
  password: string;
  status: string;
}

export interface IModelPermissionData {
  name: string;
  permission: string;
  status: string;
}

export interface IModelRoleData {
  name: string;
  status: string;
  type: string;
  permissions: IModelPermissionData[];
}

export interface IModelUserRequest {
  user: IModelUserData;
  applications: number[];
  scopes: number[];
  roles: IModelRoleData[];
}
